import getCofStatus from '../../../../helpers/get-cof-status';
import { Company, CofStatus, SignatureType } from '../../../common/types';

const getCofValues = ({
  type,
  signatureType,
  accessRight,
}: {
  type: string;
  signatureType: SignatureType;
  accessRight: string;
}) => {
  let cofType: string;
  let cofSignatureType: string;
  let cofAccessRight: string;

  switch (type) {
    case 'MAIN_REPRESENTATIVE':
      cofType = 'Main Representative';
      break;
    case 'COMPANY_OFFICIAL':
      cofType = 'Company official';
      break;
    default:
      cofType = type;
      break;
  }

  switch (signatureType) {
    case SignatureType.NONE:
      cofSignatureType = 'None';
      break;
    case SignatureType.SINGLE:
      cofSignatureType = 'Single';
      break;
    default:
      cofSignatureType = type;
      break;
  }

  switch (accessRight) {
    case 'NONE':
      cofAccessRight = 'None';
      break;
    case 'VIEWER':
      cofAccessRight = 'Viewer';
      break;
    default:
      cofAccessRight = type;
      break;
  }

  return { cofType, cofAccessRight, cofSignatureType };
};

const formatCompaniesList = (list: Company[]): Company[] => {
  const nextList = list?.map((item) => {
    const result = { ...item };

    const { cofAccessRight, cofSignatureType, cofType } = getCofValues({
      type: item.companyOfficialType,
      signatureType: item.signatureType,
      accessRight: (item?.accessRight as string) || 'NONE',
    });

    const { cofStatus, cofStatusClassName } = getCofStatus(
      result.status as CofStatus,
    );

    const render: Record<string, React.JSX.Element> = {
      organizationId: <div>{item.organization.companyName}</div>,
      companyOfficialType: (
        <div>
          {cofType}: <span className={cofStatusClassName}>{cofStatus}</span>
        </div>
      ),
      signatureType: <div>{cofSignatureType}</div>,
      accessRight: <div>{cofAccessRight}</div>,
    };

    result.render = render;

    return result;
  });

  return nextList;
};

export default formatCompaniesList;
